<template lang="pug">
.content-wrap
	.content-top
		.con
			.conbox
				.follow-wrapper
					.fubox-wrapper
						.ll(v-if="socialList.length>0")
							template(v-if="item.social_link !='' && item.social_link !=null" v-for="item in socialList" )
								.fubos.fb(v-if="item.social_platform ==='facebook'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/fb.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWin Plus PH
								.fubos.yt(v-if="item.social_platform ==='youtube'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/yt.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWin Plus PH
								.fubos.ig(v-if="item.social_platform ==='instagram'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/ig.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span @epicwinplusph
								.fubos.tl(v-if="item.social_platform ==='telegram'")
									a(:href="item.social_link" target="_blank")
										.iimg
											img(src='/new/img/contact/tl.png')
									a.w-100(:href="item.social_link" target="_blank")
										.ttext
											span EpicWin Plus PH
						.rr
							img.floating(src='/new/img/contact/jake.png')
		footerInfo(:target="'/review'")
</template>
<script>
import config from "@/config";
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
	components:{
		footerInfo
	},
	data(){
		return{
			feedback: {
        success: true,
        status: ""
      },
			loading:false,
			// socialList: [],
			imgUrl: config.imageUrl,
		}
	},
	computed:{
		socialList(){
			return this.$store.getters.getSocialList
		}
	},
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/contactUs`);
		this.getSeo("contactUs")
	},
	// metaInfo(){
	// 	if(this.$store.state.user.seoInfo.meta_title && this.$store.state.user.seoInfo.meta_title === "contactUs"){
	// 		return{
	// 			title: this.$store.state.user.seoInfo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.seoInfo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.seoInfo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.seoInfo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.seoInfo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.seoInfo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.seoInfo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.seoInfo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.seoInfo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.seoInfo.meta_image_url},
	// 			]
	// 		}
	// 	}else{
	// 		return{
	// 			title: this.$store.state.user.homeSeo.meta_title,
	// 			meta:[
	// 				{vmid: "og:title",name: 'og:title', content: this.$store.state.user.homeSeo.meta_title},
	// 				{vmid: "description",name: 'description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "og:description",name: 'og:description', content: this.$store.state.user.homeSeo.meta_desc},
	// 				{vmid: "author",name: 'author', content: this.$store.state.user.homeSeo.meta_author},
	// 				{vmid: "canonical",name: 'canonical', content: this.$store.state.user.homeSeo.meta_canonical},
	// 				{vmid: "keywords",name: 'keywords', content: this.$store.state.user.homeSeo.meta_keywords},
	// 				{vmid: "language",name: 'lang', content: this.$store.state.user.homeSeo.meta_lang},
	// 				{vmid: "url",name: 'url', content: this.$store.state.user.homeSeo.meta_url},
	// 				{vmid: "og:url",name: 'og:url', content: this.$store.state.user.homeSeo.meta_url},
	// 			],
	// 			link:[
	// 				{ rel: 'image_src', href: this.imgUrl+ this.$store.state.user.homeSeo.meta_image_url},
	// 			]
	// 		}
	// 	}
    
    
  // },
	mounted(){
		// this.getSocialList()
	},
	methods:{
		getSeo(page){
      let page_name = page
      this.$store
        .dispatch("user/getSeo", {page_name})
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
						if(response.data.length > 0){
							// this.$store.dispatch("user/seoInfo", response.data[0])
						}
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
    },
		// getSocialList(){
		// 	this.$store
		// 		.dispatch("user/getSocialList", { })
		// 		.then(response => {
		// 			if (response.success == true) {
		// 				this.socialList = response.data.value
		// 			} else {
		// 				if((typeof response.status) != 'object'){
		// 					this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
		// 				}
		// 			}
		// 		})
		// 		.catch(response => {
		// 			if((typeof response.status) != 'object'){
		// 				this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
		// 			}
		// 		});
		// }
	}
}
</script>